import { render, staticRenderFns } from "./appbookings.vue?vue&type=template&id=5a89da64&scoped=true"
import script from "./appbookings.vue?vue&type=script&lang=js"
export * from "./appbookings.vue?vue&type=script&lang=js"
import style0 from "./appbookings.vue?vue&type=style&index=0&id=5a89da64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89da64",
  null
  
)

export default component.exports